import FlowWithProvider from "../BuildNetwork/buildNetwork";

function BuildNetwork1({ info, setGame }) {
  return <FlowWithProvider info={info} setGame={setGame} />;
}

export default BuildNetwork1;
